export default __webpack_public_path__ + "static/media/TW logo text.f389800b.webp";